import React, {useEffect} from 'react'
import EntryLayout from '../layouts/entryLayout'
import { EntryPageRooms } from '../features/sakhas'
import EntryPageSuchana from '../features/suchanas/components/EntryPageSuchana';
import {useFetchInfoOfficer} from "../features/karmachari/hooks/useFetchInfoOfficer";

const EntryPage = () => {
  const { data: infoOfficerData, isLoading: infoOfficerIsLoading } = useFetchInfoOfficer()

  useEffect(() => {
    if (!infoOfficerIsLoading) {
      console.log(infoOfficerData)
    }
  }, [infoOfficerData]);

  return (
    <EntryLayout>
      <div className="h-full w-full">
        <div className="absolute top-0 left-0 w-full h-full px-6">
          <div className="flex flex-row h-full gap-8">
            <div className='w-3/4 relative flex-shrink-0'>
              <div className="absolute top-0 left-0 w-full h-full flex flex-col gap-8">
                <div className="flex-grow w-full relative overflow-auto no-scrollbar">
                  <EntryPageRooms/>
                  <br/>

                  {/*<div className="w-full aspect-video bg-gradient-to-br from-red-500 to-orange-600 relative">
                    <video
                      src="http://62.171.141.83:58/upload/e66443e81e8cc9c4fa5c099a1fb1bb87/files/अनलाइन_मार्फत_व्यक्तिगत_घटना_दर्ता।_राष्ट्रिय_परिचयपत्र_तथा_पञ्जिकरण_विभाग_।_2.mp4"
                      className='w-full h-full'
                      controls
                    />
                  </div>*/}
                  <br/>
                </div>
              </div>
            </div>
            <div className="flex-grow relative">
              <div className="absolute w-full h-full top-0 left-0 flex flex-col gap-8">
                <div className="w-full flex-grow relative border-l-2 border-l-[#d1d5db]">
                  <div className="max-h-[36vh] overflow-y-auto">
                    <EntryPageSuchana/>
                  </div>
                  <br/>
                  <div className="max-h-[44vh] overflow-y-auto">
                    { process.env.REACT_APP_HOME_SIDEBAR_HAS_MULTIPLE_MEMBERS && process.env.REACT_APP_OFFICE_CODE == "lamahimun" ?
                      <div className="p-4 font-[550] pl-4 space-y-4">
                        <div className="flex space-x-4">
                          <figure>
                            <img src="https://lamahidids.karyapalika.com/storage/images/MWB1742543688.jpg" alt="" className="h-[100px] w-auto mx-auto" />
                          </figure>
                          <div>
                            <h4 className="text-[1.4rem] font-bold">श्री जोगराज चौधरी</h4>
                            <p className="text-[1.2rem] font-bold">नगर प्रमुख</p>
                            <p className="text-[1.1rem]">9857842555</p>
                            <p>lamahinapa@gmail.com</p>
                          </div>
                        </div>
                        <div className="flex space-x-4">
                          <figure>
                            <img src="https://lamahidids.karyapalika.com/storage/images/G5q1742543841.jpg" alt="" className="h-[100px] w-auto mx-auto" />
                          </figure>
                          <div>
                            <h4 className="text-[1.4rem] font-bold">श्री लक्ष्मी योगी</h4>
                            <p className="text-[1.2rem] font-bold">उप–प्रमुख</p>
                            <p className="text-[1.1rem]">9857842444</p>
                            <p>lamahinapa@gmail.com</p>
                          </div>
                        </div>
                        <div className="flex space-x-4">
                          <figure>
                            <img src="https://lamahidids.karyapalika.com/storage/images/%20%E0%A4%97%E0%A5%87%E0%A4%B9%E0%A5%87%E0%A4%A8%E0%A5%8D%E0%A4%A6%E0%A5%8D%E0%A4%B0%20%E0%A4%AC%E0%A4%B9%E0%A4%BE%E0%A4%A6%E0%A5%81%E0%A4%B0%20%E0%A4%A1%E0%A4%BE%E0%A4%81%E0%A4%97%E0%A5%80_1765176310.jpg" alt="" className="h-[100px] w-auto mx-auto" />
                          </figure>
                          <div>
                            <h4 className="text-[1.4rem] font-bold">श्री गेहेन्द्र बहादुर डाँगी</h4>
                            <p className="text-[1.2rem] font-bold">प्रमुख प्रशासकीय अधिकृत</p>
                            <p className="text-[1.1rem]">9857837111</p>
                            <p>lamahinapa@gmail.com</p>
                          </div>
                        </div>
                      </div> :
                      <div className="p-4 text-center font-[550] pl-4">
                        <div className="mb-3">
                          <figure>
                            <img src={infoOfficerData?.image_path} alt="" className="h-[100px] w-auto mx-auto" />
                          </figure>
                        </div>
                        <h4 className="text-[1.4rem] font-bold">{infoOfficerData?.name}</h4>
                        <p className="text-[1.2rem] font-bold">सूचना अधिकारी</p>
                        <p className="text-[1.1rem]">{infoOfficerData?.contact_no}</p>
                        <p>{infoOfficerData?.email}</p>
                      </div>
                    }
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

    </EntryLayout>
  )
}

export default EntryPage
